import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { ChatBox } from '@pegasus/ui-chatbox';

import { TranslateScope, Translate } from '@pegasus/translation/components';

import { getCustomer } from '@client/redux/modules/customer/selectors';
import { ConfigContext } from '@client/hoc/config/ConfigContext';

const appdomain = Number(typeof window !== 'undefined' && window.APPDOMAIN);

export const ChatBoxWrapper = () => {
    const { config } = useContext(ConfigContext);
    const customer = useSelector(getCustomer);
    const livechatConfig = {
        livechat: {
            buttonId: config.livechat.id,
            ...config.livechat,
        },
        appdomain,
    };

    return (
        <TranslateScope path="livechat">
            <ChatBox
                customer={customer}
                config={livechatConfig}
                offlineMessage={<Translate message="unavailable" />}
                onlineMessage={<Translate message="available" />}
            />
        </TranslateScope>
    );
};

export default ChatBoxWrapper;
